import React from "react";
import { HashLink } from "react-router-hash-link";
import { Link } from "react-router-dom";
import { AiFillFacebook, AiFillGoogleCircle } from "react-icons/ai";
import { FaTripadvisor, FaInstagram } from "react-icons/fa";

import { Img } from "component/FrameL";
import { FooterSchema } from "utils/schemas/footer-schema";

import BespokeLogo from "assets/bespoke_footer_icon.png";
import "./style.css";

const Footer = ({ cmsData = {} }) => {
  const {
    HotelName,
    HotelAddress1,
    HotelAddress2,
    PhoneLocal,
    Facebook,
    Instagram,
    Email,
    TripAdvisor,
  } = cmsData;
  const GoogleReviewsLink =
    "https://www.google.com/travel/search?q=union%20inn%20nantucket%20ma%20google%20reviews&g2lb=4814050%2C4874190%2C4893075%2C4965990%2C10210222%2C72277293%2C72302247%2C72317059%2C72406588%2C72414906%2C72421566%2C72462234%2C72470899%2C72471280%2C72472051%2C72473841%2C72481459%2C72485658%2C72486593%2C72494250%2C72499705%2C72513513%2C72520079%2C72536387%2C72549171%2C72569093%2C72570850%2C72602734%2C72605013%2C72606237%2C72614662%2C72616120%2C72619927%2C72620306%2C72620956%2C72624691%2C72626061%2C72634629%2C72648289%2C72653659&hl=en-US&gl=us&ssta=1&ts=CAEaRwopEicyJTB4ODlmYWRkMjAwYTFlNDQwNzoweGIzODYzYjlkYTdiOGJhYzMSGhIUCgcI6A8QBxgHEgcI6A8QBxgIGAEyAhAA&qs=CAEyFENnc0l3X1hpdmRyempzT3pBUkFCOAJCCQnDurinnTuGs0IJCcO6uKedO4az&ap=ugEHcmV2aWV3cw&ictx=111&ved=0CAAQ5JsGahcKEwiwp_7c2pCHAxUAAAAAHQAAAAAQCw";

  if (!cmsData) {
    return null;
  }

  return (
    <>
      <FooterSchema footerData={cmsData} />
      <footer className="footer">
        <div className="footer__inner max-w-screen-xl">
          {/* Left: Contact Info + Copyright + Bespoke */}
          <div className="footer__section">
            {/* Google Reviews - commented out for now */}
            {/* <a
              href={GoogleReviewsLink}
              target="_blank"
              rel="noopener noreferrer"
              className="footer__google-link"
              aria-label="Google Reviews - 5 Stars"
            >
              <svg>...</svg>
              <div className="footer__stars">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} className="footer__star" />
                ))}
              </div>
            </a> */}
            <p className="footer__text">{HotelAddress1}</p>
            <p className="footer__text">{HotelAddress2}</p>
            <p className="footer__text">Phone: {PhoneLocal}</p>
            <p className="footer__text">
              Email:{" "}
              <a className="footer__link" href={`mailto:${Email}`}>
                {Email}
              </a>
            </p>
            <p className="footer__copyright">
              © {new Date().getFullYear()} {HotelName} ®
            </p>
            <div className="footer__bespoke">
              <Img isExternal={false} src={BespokeLogo} alt="Bespoke Logo" width={94} height={112} />
            </div>
          </div>

          {/* Center: Email Signup & Social */}
          <div className="footer__section footer__section--center">
            <HashLink to="/about#email-signup" className="footer__signup-link">
              Email Signup
            </HashLink>
            <p className="footer__text">
              For the latest news and last minute specials.
            </p>

            <p className="footer__follow-label">Follow Us</p>
            <div className="footer__social">
              <a
                href={TripAdvisor}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Trip Advisor Link"
                className="footer__social-link"
              >
                <FaTripadvisor />
              </a>
              <a
                href={Facebook}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook Link"
                className="footer__social-link"
              >
                <AiFillFacebook />
              </a>
              <a
                href={Instagram}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram Link"
                className="footer__social-link"
              >
                <FaInstagram />
              </a>
              <a
                href={GoogleReviewsLink}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Google Reviews"
                className="footer__social-link"
              >
                <AiFillGoogleCircle />
              </a>
            </div>
          </div>

          {/* Right: Navigation */}
          <div className="footer__section footer__section--end">
            <nav className="footer__nav">
              <Link to="/faq" className="footer__nav-link">
                FAQ
              </Link>
              <Link to="/policies" className="footer__nav-link">
                Policies
              </Link>
              <Link to="/health-policies" className="footer__nav-link">
                Covid 19 Health Policies
              </Link>
              <Link to="/press" className="footer__nav-link">
                Press
              </Link>
              <a
                aria-label="Gift Certificates Link"
                className="footer__nav-link"
                href="https://secure.thinkreservations.com/unioninn/gift-certificates"
              >
                Gift Certificates
              </a>
            </nav>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
